import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'

import Modal from '../../UniformComponents/Modal'
import Typography from '../../UniformComponents/Typography'
import Button from '../../UniformComponents/Button'
import Input from '../form/Input'
import Select from '../form/Select'

const PresentationTemplateModal = ({ templateSearchStore, history }) => {
    const {
        newTemplateName,
        newTemplateSurveyType,
        newTemplateRespondentType,
        newTemplateEvent,
    } = templateSearchStore

    const canCreate = !!newTemplateName.length
        && !!newTemplateSurveyType
        && !!newTemplateRespondentType
        && !!newTemplateEvent

    return (
        <Modal
            show={templateSearchStore.createPresentationModalVisible}
            onClose={templateSearchStore.closeCreatePresentationModal}
        >
            <Typography type="h2">{i18n.t('templates.create.presentation.title')}</Typography>

            <br />

            <hr />

            <br />

            <Input
                name="template-name"
                label={i18n.t('templates.templateName')}
                value={newTemplateName}
                onChange={templateSearchStore.setNewTemplateName}
                placeholder={i18n.t('templates.create.presentation.namePlaceholder')}
            />

            <br />

            <Select
                name="survey-type"
                label={i18n.t('templates.surveyType')}
                options={templateSearchStore.templateSurveyTypeOptions}
                value={newTemplateSurveyType}
                onBlur={({ value }) => templateSearchStore.setNewTemplateSurveyType(value)}
                placeholder={i18n.t('templates.create.presentation.surveyTypePlaceholder')}
            />

            <br />

            <Select
                name="respondent-type"
                label={i18n.t('templates.respondentType')}
                options={templateSearchStore.templateRespondentTypeOptions(newTemplateSurveyType)}
                value={newTemplateRespondentType}
                onBlur={({ value }) => templateSearchStore.setNewTemplateRespondentType(value)}
                placeholder={i18n.t('templates.create.presentation.respondentTypePlaceholder')}
                showDisabled={!newTemplateSurveyType}
            />

            <br />

            <Select
                name="event"
                label={i18n.t('templates.create.presentation.event')}
                options={templateSearchStore.templateEventOptions(newTemplateSurveyType, newTemplateRespondentType)}
                value={newTemplateEvent}
                onBlur={({ value }) => templateSearchStore.setNewTemplateEvent(value)}
                placeholder={i18n.t('templates.create.presentation.eventPlaceholder')}
                showDisabled={!newTemplateRespondentType}
            />

            <br />

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
                <Button
                    label={i18n.t('cancel')}
                    onClick={templateSearchStore.closeCreatePresentationModal}
                    cssClass="regular tertiary"
                />
                <Button
                    icon="fa-light fa-circle-plus"
                    label={i18n.t('templates.create.presentation.submit')}
                    onClick={() => templateSearchStore.createPresentationTemplate(history)}
                    cssClass="regular primary"
                    disabled={!canCreate}
                />
            </div>
        </Modal>
    )
}

export default observer(PresentationTemplateModal)
